module.exports = __webpack_public_path__ + "media/images/btn_side-230b2ff97ed42ccb7c67952836c42360.gif";